import axios from "axios";
import ApiRoutes from "../utils/api_routes";

const axiosInstance = axios.create({
  baseURL: `${ApiRoutes.baseUrl}/api`,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("employeeToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const message = error.response.data?.message;

      if (
        message === "User account is inactive" ||
        message === "Invalid Token"
      ) {
        localStorage.clear();

        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
